<template>
  <div class="timeline-footer">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'timeline-footer',
  props: {}
};
</script>

<style>
  
</style>




// WEBPACK FOOTER //
// src/components/UIComponents/Timeline/TimelineFooter.vue